import request from '../utils/request'

/**
 * 获取字典数据（根据分类代码）- 业务员端
 */
export function getDictDataByCode(categoryCode) {
  return request({
    url: '/salesman/dict-data/by-code',
    method: 'get',
    params: { categoryCode }
  })
}

